export type Condition = {
  slug: string;
  path: string;
  name: string;
  title: string;
  intro: string;
  symptoms: string[];
  treatment: string;
};

export const conditions: Condition[] = [
  {
    slug: 'back-pain',
    path: '/back-pain-bradford',
    name: 'Back Pain',
    title: 'Back Pain Physiotherapy Bradford',
    intro:
      'At YH Physio & Performance in Bradford, we assess and treat back pain caused by posture, injury, or daily strain.',
    symptoms: [
      'Lower back pain or stiffness',
      'Difficulty bending or moving',
      'Pain sitting or standing'
    ],
    treatment:
      'Physiotherapy may include hands on treatment, exercise prescription, and advice to help reduce pain and improve movement.'
  },
  {
    slug: 'neck-pain',
    path: '/neck-pain-bradford',
    name: 'Neck Pain',
    title: 'Neck Pain Physiotherapy Bradford',
    intro:
      'At YH Physio & Performance in Bradford, we assess and treat neck pain caused by posture, tension, or injury.',
    symptoms: [
      'Neck stiffness or pain',
      'Headaches linked to neck tension',
      'Pain turning the head',
      'Pins and needles down the arm',
      'Difficulty sleeping'
    ],
    treatment:
      'Physiotherapy may include hands on treatment, exercise rehabilitation, acupuncture, and posture advice.'
  },
  {
    slug: 'sciatica',
    path: '/sciatica-bradford',
    name: 'Sciatica',
    title: 'Sciatica Physiotherapy Bradford',
    intro:
      'At YH Physio & Performance in Bradford, we assess and treat sciatica causing pain down the leg.',
    symptoms: [
      'Pain radiating down the leg',
      'Sharp or shooting pain',
      'Tingling or numbness',
      'Lower back pain',
      'Struggling to sleep'
    ],
    treatment:
      'Physiotherapy may include hands on treatment, nerve glide exercises, acupuncture, and guided rehabilitation.'
  },
  {
    slug: 'frozen-shoulder',
    path: '/frozen-shoulder-bradford',
    name: 'Frozen Shoulder',
    title: 'Frozen Shoulder Physiotherapy Bradford',
    intro:
      'At YH Physio & Performance in Bradford, we treat frozen shoulder causing stiffness, pain and reduced shoulder movement.',
    symptoms: [
      'Pain with or without movement',
      'Shoulder stiffness',
      'Difficulty lifting the arm',
      'Night pain',
      'Difficulty sleeping',
      'Struggling to comb your hair',
      'Pins and needles down arm'
    ],
    treatment:
      'Physiotherapy may include hands on treatment, stretches to improve movement, steroid injection or advice on how to get referred for a hydrodistension injection.'
  },
  {
    slug: 'rotator-cuff-injury',
    path: '/rotator-cuff-injury-bradford',
    name: 'Rotator Cuff Injury',
    title: 'Rotator Cuff Injury Physiotherapy Bradford',
    intro:
      'At YH Physio & Performance in Bradford, we assess and treat rotator cuff injuries causing shoulder pain and weakness.',
    symptoms: [
      'Shoulder pain when lifting',
      'Weakness in the arm',
      'Pain lying on that shoulder'
    ],
    treatment:
      'Physiotherapy may include strengthening exercises, some hands on treatment, acupuncture or steroid injection to help manage pain.'
  },
  {
    slug: 'tennis-elbow',
    path: '/tennis-elbow-bradford',
    name: 'Tennis Elbow',
    title: 'Tennis Elbow Physiotherapy Bradford',
    intro:
      'At YH Physio & Performance in Bradford, we treat tennis elbow causing pain around the outside of the elbow.',
    symptoms: [
      'Elbow pain when gripping',
      'Pain lifting objects',
      'Weak grip strength',
      'Pain on touching outer side of elbow'
    ],
    treatment:
      'Physiotherapy may include gentle loading exercises, soft tissue work and advice to reduce strain.'
  },
  {
    slug: 'golfers-elbow',
    path: '/golfers-elbow-bradford',
    name: 'Golfer’s Elbow',
    title: 'Golfer’s Elbow Physiotherapy Bradford',
    intro:
      'At YH Physio & Performance in Bradford, we assess and treat golfers elbow causing pain on the inside of the elbow and forearm.',
    symptoms: [
      'Pain on inside of elbow',
      'Pain gripping or lifting',
      'Forearm discomfort or weakness'
    ],
    treatment:
      'Physiotherapy may include gentle loading exercises, soft tissue treatment, and advice to reduce strain and support recovery.'
  },
  {
    slug: 'knee-pain',
    path: '/knee-pain-bradford',
    name: 'Knee Pain',
    title: 'Knee Pain Physiotherapy Bradford',
    intro:
      'At YH Physio & Performance in Bradford, we assess and treat knee pain caused by arthritis, injury, or overuse.',
    symptoms: [
      'Pain when walking or running',
      'Stiffness or swelling',
      'Difficulty exercising',
      'Pain using the stairs',
      'Pain when kneeling'
    ],
    treatment:
      'Physiotherapy may include strengthening exercises, hands on treatment, and movement rehabilitation.'
  },
  {
    slug: 'ankle-pain',
    path: '/ankle-pain-bradford',
    name: 'Ankle Pain',
    title: 'Ankle Pain Physiotherapy Bradford',
    intro:
      'At YH Physio & Performance in Bradford, we assess and treat ankle pain caused by injury, sprains, or overuse.',
    symptoms: [
      'Pain or swelling around the ankle',
      'Difficulty walking or weight bearing',
      'Instability or weakness'
    ],
    treatment:
      'Physiotherapy may include rehabilitation exercises, mobility work, balance training, and hands-on treatment.'
  },
  {
    slug: 'hip-pain',
    path: '/hip-pain-bradford',
    name: 'Hip Pain',
    title: 'Hip Pain Physiotherapy Bradford',
    intro:
      'At YH Physio & Performance in Bradford, we assess and treat hip pain caused by strain, arthritis, or injury.',
    symptoms: [
      'Hip or groin pain',
      'Stiffness when moving',
      'Pain walking or standing',
      'Pain lying on that side'
    ],
    treatment:
      'Physiotherapy may include mobility work, strengthening exercises, and hands on treatment.'
  },
  {
    slug: 'plantar-fasciitis',
    path: '/plantar-fasciitis-bradford',
    name: 'Plantar Fasciitis',
    title: 'Plantar Fasciitis Physiotherapy Bradford',
    intro:
      'At YH Physio & Performance in Bradford, we assess and treat plantar fasciitis causing heel pain, especially with walking or standing.',
    symptoms: [
      'Heel pain (often worse in the morning)',
      'Pain when walking or standing',
      'Tenderness under the foot'
    ],
    treatment:
      'Physiotherapy may include loading and strengthening exercises, soft tissue treatment, and advice on footwear and load management.'
  }
];

export function getConditionByPath(path: string): Condition | undefined {
  return conditions.find((condition) => condition.path === path);
}
